import { render, staticRenderFns } from "./webColumn.vue?vue&type=template&id=4e2fc990&scoped=true&"
import script from "./webColumn.vue?vue&type=script&lang=js&"
export * from "./webColumn.vue?vue&type=script&lang=js&"
import style0 from "./webColumn.vue?vue&type=style&index=0&id=4e2fc990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fc990",
  null
  
)

export default component.exports